import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonMenuButton,
  IonContent,
} from '@ionic/react';
import ListingsContent from '../components/ListingsContent';

const Listings: React.FC = () => (
  <IonPage>
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton menu="main-menu" />
        </IonButtons>
        <IonTitle>Listings</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent fullscreen className="bg-gray-50 dark:bg-gray-900">
      <ListingsContent />
    </IonContent>
  </IonPage>
);

export default Listings;
